export default "__VITE_ASSET__CcF9$f2C__"